import { render, staticRenderFns } from "./AppReceiverFixCount.vue?vue&type=template&id=778dcf83&scoped=true&"
import script from "./AppReceiverFixCount.vue?vue&type=script&lang=js&"
export * from "./AppReceiverFixCount.vue?vue&type=script&lang=js&"
import style0 from "./AppReceiverFixCount.vue?vue&type=style&index=0&id=778dcf83&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "778dcf83",
  null
  
)

export default component.exports